import React from 'react';
import { Box, Tooltip } from '@mui/material';
import type { HealthStatus } from '@/config/portalHealth';

const COLOR: Record<HealthStatus, string> = {
  checking: '#94a3b8',
  up: '#22c55e',
  down: '#ef4444',
  partial: '#f59e0b',
  protected: '#2563eb',
};

const LABEL: Record<HealthStatus, string> = {
  checking: '检测中…',
  up: '已验证在线',
  down: '不可达',
  partial: '部分异常（前端或后端未通过检测）',
  protected: '入口可达，健康状态需登录授权后验证',
};

interface HealthDotProps {
  status: HealthStatus;
  label?: string;
  size?: number;
}

export const HealthDot: React.FC<HealthDotProps> = ({ status, label, size = 10 }) => {
  const color = COLOR[status];
  const title = label ? `${label} · ${LABEL[status]}` : LABEL[status];
  return (
    <Tooltip title={title} arrow>
      <Box
        data-testid={`health-dot-${status}`}
        sx={{
          width: size,
          height: size,
          borderRadius: '50%',
          bgcolor: color,
          flexShrink: 0,
          boxShadow: `0 0 0 3px ${color}29`,
          animation: status === 'checking' ? 'kxHealthPulse 1.4s ease-in-out infinite' : 'none',
          '@keyframes kxHealthPulse': {
            '0%, 100%': { opacity: 0.5 },
            '50%': { opacity: 1 },
          },
        }}
      />
    </Tooltip>
  );
};
